import makeOnMessageHandler from './makeOnMessageHandler'

export default makeOnMessageHandler

